import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "dateFrom" }, "Date From", -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "dateTo" }, "Date To", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "filterName" }, "Or Filter", -1)
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = { class: "p-col" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "statusId" }, "User", -1)
const _hoisted_13 = { class: "p-col" }
const _hoisted_14 = {
  key: 0,
  class: "p-field"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "supplierId" }, "Supplier", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '50vw' },
    maximizable: true,
    position: "top",
    class: "p-fluid",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        type: "submit",
        label: "Search",
        icon: "pi pi-search",
        class: "p-button-primary",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.searchRecords()), ["prevent"]))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Calendar, {
          id: "dateFrom",
          modelValue: _ctx.item.date1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.date1) = $event)),
          selectionMode: "single",
          dateFormat: "dd-mm-yy",
          onClick: _ctx.clearFilterName
        }, null, 8, ["modelValue", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Calendar, {
          id: "dateTo",
          modelValue: _ctx.item.date2,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.date2) = $event)),
          selectionMode: "single",
          dateFormat: "dd-mm-yy",
          onClick: _ctx.clearFilterName
        }, null, 8, ["modelValue", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Dropdown, {
          id: "filterName",
          modelValue: _ctx.item.filterName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.filterName) = $event)),
          options: _ctx.filterList,
          optionLabel: "key",
          onChange: _ctx.clearDates
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Dropdown, {
              id: "statusId",
              modelValue: _ctx.item.userID,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.userID) = $event)),
              options: _ctx.userList,
              filter: true,
              optionLabel: "name",
              optionValue: "id"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.supplierFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_Dropdown, {
                  id: "supplierId",
                  modelValue: _ctx.item.supplierID,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.supplierID) = $event)),
                  options: _ctx.supplierList,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}